export const environment = {
  domain: 'staging',
  hsId: 23538888,
  disablev6: true,
  production: false,
  originDomain: 'staging-nfconsole.io', // Allowed Origin in auth0 (root domain)
  originPort: false,
  gatewayUrl: 'gateway.staging.netfoundry.io',
  apiUrl: 'https://gateway.staging.netfoundry.io/rest/v1/',
  clientSyncsApiUlr: 'https://gateway.staging.netfoundry.io/clientsync/v1/',
  netflowUrl: 'https://gateway.staging.netfoundry.io/netflow/v1/',
  downloadsURL: 'https://netfoundry.io/resources/support/downloads/networkversion',
  customerURL: 'https://gateway.staging.netfoundry.io/customer/v1/',
  appsURL: 'https://gateway.staging.netfoundry.io/apps/v1/',
  bannerURL: 'https://gateway.staging.netfoundry.io/banner/v1/',
  kibanaURL: 'https://kibana-staging-internal-netfoundry-io.kb.us-east-1.aws.found.io:9243/',
  elasticConfig: {
    usePublicApi: true,
    reportingServiceUrl: 'https://gateway.staging.netfoundry.io/reporting/v1/elastic',
    reportingServiceEnabled: true,
    reportingTemplateServiceUrl: 'https://gateway.staging.netfoundry.io/reporting/v1/template-search',
  },
  defaultNetworkConfigName: 'medium',
  defaultSize: 'medium',
  defaultLocationCode: 'us-east-1',
  authconfig: {
    clientID: 'yf1HOLPaVC12MMUNpmOtof6SBKjWg0kp',
    domain: 'netfoundry-staging.auth0.com',
    callbackURL: 'https://sinec.staging-nfconsole.io/callback',
    // Namespace for where the organization ID is stored in the auth token
    jwtOrgKey: 'https://netfoundry.io/organization_id',
    audience: 'https://gateway.staging.netfoundry.io/',
    newSignupRedirect: 'https://sinec.staging-nfconsole.io/signup-return',
  },
  identityConfig: {
    url: 'https://gateway.staging.netfoundry.io/identity/v1/',
    invitationUrl: 'https://sinec.staging-nfconsole.io/invitation',
    intermediateReturnUrl: 'https://sinec.staging-nfconsole.io/invitation',
    registrationReturnUrl: 'https://sinec.staging-nfconsole.io/signup',
    loginReturnUrl: 'https://sinec.staging-nfconsole.io/login',
  },
  billingConfig: {
    // this is subject to change
    billingUrl: 'https://gateway.staging.netfoundry.io/billing/v1/',
    // stripe staging environment
    stripe: 'pk_live_JVRJaDMuJC0g13wm66FRjviY',
  },
  chargebeeConfig: {
    // this is subject to change
    site: 'netfoundry',
    // chargebee staging environment
    publishableKey: 'live_VrWGPcdgqqmAt7sjcuvt7YRfdTnXXn4AHw',
  },
  // temporary property for the how long the session timeout should be. This should get replaced once the API supports session timeout
  defaultSessionTimeoutSeconds: 1800,
  // temporary property for how long before the session timeout the user should be warned about the timeout
  defaultTimeoutWarningSeconds: 60,
  // two hour timeout for endpoint session users
  endpointSessionTimeoutSeconds: 43200,
  pageSize: 30,
  // list of comma separated email ids of test robots. If the current profile's email id is matching with any of the given test user
  // email ids, then some of the functionalities will be hidden or diabled.
  internalTestUserEmailIds: 'nf_test1@netfoundry.io',
  authorizationUrl: 'https://gateway.staging.netfoundry.io/auth/v1/',
  reportingUrl: 'https://gateway.staging.netfoundry.io/reports/v1',
  gtmLink:
    'https://www.googletagmanager.com/ns.html?id=GTM-TG778K4&gtm_auth=_q0-lGoQ-Myz8lj8MZVmGQ&gtm_preview=env-18&gtm_cookies_win=x',
  v2apiUrl: 'https://gateway.staging.netfoundry.io/core/v2/',
  v3apiUrl: 'https://gateway.staging.netfoundry.io/core/v3/',
  notificationUrl: 'https://gateway.staging.netfoundry.io/notification/v1',
  registrationIp: '184.72.146.130, 35.175.23.123',
  // TODO: remove when MOP can handle custom timeouts
  pldtTimeoutSeconds: 32000,
  pldtId: 'a37f806b-4f49-48f2-aa28-d850d5f24b8c',
  sampleServiceUrl: 'https://sample.tools.netfoundry.io',
  hideSubmitTicket: true,
  hideZiggy: true,
  showDefaultLogo: true,
  enableCustomLoadingIndicator: true,
  titleName: 'Siemens',
  gatewayApiUrl: 'https://gateway.staging.netfoundry.io/',
  orgId: 'C74F5659-B6DE-4EE5-9125-36F9A748DCE9',
  alwaysVanityUrl: true,
  realmsSupported: true,
};
